import React from 'react';
import { Link } from 'react-router-dom';

class FooterLeftCol extends React.Component {
  render() {
    const colData = this.props.leftFooter['product-social-links'] ? this.props.leftFooter['product-footer'].menu : this.props.leftFooter.menu;
    return (
      this.props !== undefined
      && (
      <div className="col-xs-12 col-sm-7 col-md-7 col-lg-4 order-sm-1 footer-mobile-padding">
        <div>
          <label className="footer-heading">{colData !== undefined && colData.name.toUpperCase()}</label>
          {colData !== undefined
          && colData.items.map((item) => ( 
            item.title === 'See All Products' ? (           
            <React.Fragment key={item.title}>
              <p className="foolter-content">
                <a href={item.url} className="exploreLink">{item.title}</a>
              </p>
            </React.Fragment>
            ) : (
              <React.Fragment key={item.title}>
              <p className="foolter-content">
                {(item.url.indexOf('http://') === 0 || item.url.indexOf('https://') === 0)?
                <a href={item.url}>{item.title}</a>:
                <Link to={item.url}>{item.title}</Link>
                }
              </p>
            </React.Fragment>
            )
          ))}
        </div>
      </div>
      )
    );
  }
}

export default FooterLeftCol;
